import {
  BurgerIcon,
  CircleQuestionIcon,
  LabelIcon,
  PenIcon,
  RightArrowIcon
} from "assets/icons";
import cn from "classnames";
import { If } from "components";
import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import { CategoryItemProps } from "./CategoryItem.types";

import styles from "./CategoryItem.module.scss";

const CategoryItem = ({
  name,
  image,
  isSelected,
  isViewMode,
  isSubChildCategory,
  isAttributes,
  canEditUsageGuide = false,
  onEdit,
  onEditUsageGuide,
  onSelect
}: CategoryItemProps) => {
  const { t } = useTranslation();

  const onEditCategory = (e: MouseEvent) => {
    e.stopPropagation();
    onEdit();
  };

  const onEditCategoryUsageGuide = (e: MouseEvent) => {
    e.stopPropagation();
    onEditUsageGuide?.();
  };

  return (
    <div
      className={cn(styles["category-item"], {
        [styles["category-item-selected"]]: isSelected
      })}
      onClick={onSelect}
    >
      <If condition={!isViewMode}>
        <Icon as={BurgerIcon} boxSize={12} color="#A8A8BB" />
      </If>

      <If condition={image}>
        <div
          className={cn(styles["category-item__image"], {
            [styles["category-item__image-large"]]: isSubChildCategory
          })}
        >
          <img className="default-image" src={image as string} alt={name} />
        </div>
      </If>

      <div className={styles["category-item__content"]}>
        <div
          className={cn(styles["category-item__content--title"], {
            [styles["category-item__content--title-selected"]]: isSelected
          })}
        >
          {name}
        </div>

        <If condition={isSubChildCategory}>
          <div
            className={cn(styles["category-item__content--attribute"], {
              [styles["category-item__content--attribute-active"]]: isAttributes
            })}
          >
            <Icon
              as={LabelIcon}
              boxSize={13}
              color={isAttributes ? "#ff0033" : "#A8A8BB"}
            />
            {isAttributes ? t("Attributes added") : t("No attributes")}
          </div>
        </If>
      </div>

      <If condition={!isViewMode && canEditUsageGuide}>
        <span
          className={styles["category-item__guide-icon"]}
          title={t("How to use + FAQ")}
        >
          <Icon
            type="button"
            as={CircleQuestionIcon}
            boxSize={20}
            onClick={onEditCategoryUsageGuide}
          />
        </span>
      </If>

      <If condition={!isViewMode}>
        <Icon
          type="button"
          as={PenIcon}
          boxSize={20}
          color="#A8A8BB"
          onClick={onEditCategory}
        />
      </If>

      <If condition={!isSubChildCategory}>
        <Icon as={RightArrowIcon} boxSize={24} color="#090914" />
      </If>
    </div>
  );
};

export default CategoryItem;
